module.exports = __webpack_public_path__ + "img/etherbit.2eb0917d.svg";